export const getFinancialSummaryItems = (reportCode, summary = {}) => {
  if (reportCode === 'FIN-003' && summary.TOTALASSETS !== undefined) {
    return [
      ['Tổng tài sản', summary.TOTALASSETS],
      ['Nợ phải trả', summary.TOTALLIABILITIES],
      ['Vốn chủ sở hữu', summary.TOTALEQUITY],
      ['Chênh lệch tài sản − nguồn vốn', summary.BALANCEDIFFERENCE],
    ];
  }
  return [
    ['Tổng kỳ này', summary.CURRENTAMOUNT],
    ['Tổng kỳ trước', summary.PREVIOUSAMOUNT],
    ['Số chỉ tiêu', summary.TOTALITEMS, false],
    ['Số dòng có số liệu', summary.LINECOUNT, false],
  ];
};
